import React from "react";
import "./behanceprjs.css";
const Behanceprjs = () => {
  return (
    <div className="behance_wrapper">
      <div className="behance_components">
        <iframe
          src="https://www.behance.net/embed/project/212971763?ilo0=1"
          height="316"
          width="404"
          allowfullscreen
          lazyload
          frameborder="0"
          allow="clipboard-write"
          refererPolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
      <div className="behance_components">
        <iframe
          src="https://www.behance.net/embed/project/196275937?ilo0=1"
          height="316"
          width="404"
          allowfullscreen
          lazyload
          frameborder="0"
          allow="clipboard-write"
          refererPolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
      <div className="behance_components">
        <iframe
          src="https://www.behance.net/embed/project/194096535?ilo0=1"
          height="316"
          width="404"
          allowfullscreen
          lazyload
          frameborder="0"
          allow="clipboard-write"
          refererPolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
      <div className="behance_components">
        <iframe
          src="https://www.behance.net/embed/project/190665211?ilo0=1"
          height="316"
          width="404"
          allowfullscreen
          lazyload
          frameborder="0"
          allow="clipboard-write"
          refererPolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
      <div className="behance_components">
        <iframe
          src="https://www.behance.net/embed/project/190658625?ilo0=1"
          height="316"
          width="404"
          allowfullscreen
          lazyload
          frameborder="0"
          allow="clipboard-write"
          refererPolicy="strict-origin-when-cross-origin"
        ></iframe>{" "}
      </div>
    </div>
  );
};

export default Behanceprjs;
